module.exports = __webpack_public_path__ + "img/health-getaways.ea3db373.png";